<template>
  <div>
    <page-title-bar>
        <v-btn fab dark color="indigo" small @click="create()">
            <v-icon dark>add</v-icon>
        </v-btn>
    </page-title-bar>
    <!-- <app-section-loader :status="loader"></app-section-loader> -->
  	<v-container fluid grid-list-xl>
      <v-layout row wrap>
        <app-card
            :fullBlock="true"
            colClasses="xl12 lg12 md12 sm12 xs12">

          <v-data-table
            v-bind:headers="headers"
            :items="dashboards"
            hide-actions>
            <template slot="items" slot-scope="props">
                <td>{{ props.item.settings.name[$i18n.locale] }}</td>
                <td>{{ props.item.widgets.length }}</td>
                <td class=" justify-center layout px-0">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(props.item)">
                        edit
                    </v-icon>
                    <v-icon
                        small
                        @click="deleteItem(props.item)">
                        delete
                    </v-icon>
                </td>
            </template>
          </v-data-table>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueGridLayout from "vue-grid-layout"
import defaultDashboard from './default-dashboard'

export default {
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem
    },
    data() {
        return {
            headers: [
                { text: "Name" },
                { text: "Widgets", value: "fat" },
                {
                    text: 'Actions',
                    align: 'center'
                }
            ]
        };
    },
    computed: {
        ...mapGetters([
            'dashboards'
        ]),
        dataSource: function() {
            if (this.$refs.grid) {
                const pivotGrid = this.$refs.grid.instance;
                return pivotGrid.getDataSource()
            }
        }
    },
    methods: {
        create () {
            // this.$router.push({ name: 'admin.create-dashboard' })
            this.$store.dispatch('newDashboard', defaultDashboard)
                .then(() => this.$store.dispatch('getDashboards'))

        },
        editItem (item) {
            this.$router.push({ name: 'admin.dashboard', params: { id: item._id }})
        },
        deleteItem (item) {
            this.$confirm(`Do you really want to delete the Dashboard "${item.settings.name[this.$i18n.locale]}"?`, {
                color: 'warning',
                icon: 'warning',
                title: 'Warning'
            }).then(res => {
                if (res === true) {
                    this.$store.dispatch('deleteDashboard', item._id)
                }
            })
        }
    },
    created () {
		//  const pivotGrid = this.$refs.grid.instance
		this.$store.dispatch('getDashboards')
	}
};
</script>
